import React from "react";
import Screen1 from "./components/Screen1";

export default function NewHome() {
  return <Screen1 />;
}
